<template lang="pug">
.study-result-student-select-list
  //- サイドメニュー部
  side-menu.study-result-student-select-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-result-student-select-list__content
    breadcrumb-list.study-result-student-select-list__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent'
    )
    .study-result-student-select-list__content__body
      .study-result-student-select-list__content__body__heading
        tab-heading.study-result-student-select-list__content__body__heading__tab(:isActive='true') {{ titleText }}
      .study-result-student-select-list__content__body__main
        .study-result-student-select-list__content__body__main__action
          search-result-student.study-result-student-select-list__content__body__main__action__search(
            :gradeSelectOptions='gradeSelectOptions',
            :gradeValue='gradeValue',
            :fullName='fullName',
            :status='status',
            :fullNamePlaceholder='fullNamePlaceholder',
            :statusPlaceholder='statusPlaceholder',
            :gradeChangeEvent='setGradeValue',
            :fullNameChangeEvent='setFullName',
            :statusChangeEvent='setStatus',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
          .study-result-student-select-list__content__body__main__action__button
            button-icon-circle.study-result-student-select-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
        student-select-list-table.study-result-student-select-list__content__body__main__table(
          v-if='sort && studentDatas',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :studentDatas='studentDatas',
          :resultButtonEvent='resultButtonEvent'
        )
          template(#nickNameHeader)
            slot(name='nickNameHeader')
          template(#gradeNameHeader)
            slot(name='gradeNameHeader')
          template(#statusNameHeader)
            slot(name='statusNameHeader')
          template(#branchNameHeader)
            slot(name='branchNameHeader')
          template(#lastMinuteCheckStatusHeader)
            slot(name='lastMinuteCheckStatusHeader')
          template(#resolveStatusHeader)
            slot(name='resolveStatusHeader')
          template(#resultButtonLabel)
            slot(name='resultButtonLabel')
        .study-result-student-select-list__content__body__main__footer
          button-pagination.study-result-student-select-list__content__body__main__footer__pager(
            :status='pagenationStatus',
            @click='pagenationEvent'
          )
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchResultStudent from '@/components/organisms/manager/SearchResultStudent.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import StudentSelectListTable from '@/components/organisms/manager/StudentSelectListTable.vue'
import ButtonPagination from '@/components/molecules/manager/ButtonPagination.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudentSelectListType, StudentSelectListSortType } from '@/models/studentListModel'
import { InputItem } from '@/models/inputItem'
import { PaginationStatus } from '@/models/paginationModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { SortSetting } from '@/const/SortSettings'

/**
 * 履歴管理・生徒を選ぶ画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchResultStudent,
    ButtonIconCircle,
    StudentSelectListTable,
    ButtonPagination,
  },
})
export default class StudyResultStudentSelectList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // タイトル文字列
  @Prop()
  titleText!: string

  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // ステータスプレースホルダー
  @Prop()
  statusPlaceholder!: string

  // 検索イベント
  @Prop()
  searchEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudentSelectListSortType

  // 生徒選択一覧表示情報
  @Prop()
  studentDatas!: StudentSelectListType[]

  // 成績表ボタン押下時イベント
  @Prop()
  resultButtonEvent!: Function

  // ページネーションの状態
  @Prop()
  pagenationStatus!: PaginationStatus

  // ページネーションイベント
  @Prop()
  pagenationEvent!: Function

  // === 選択値を保持する変数群
  // 学年
  public gradeValue = ''
  // 氏名
  public fullName = ''
  // ステータス
  public status = ''

  // === 選択値をセットする関数群
  // 学年をセット
  private setGradeValue(value: string) {
    this.gradeValue = value
  }
  // 氏名をセット
  private setFullName(value: string) {
    this.fullName = value
  }
  // ステータスをセット
  private setStatus(value: string) {
    this.status = value
  }

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: keyof StudentSelectListSortType) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }
}
</script>

<style lang="stylus" scoped>
.study-result-student-select-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__footer
          display flex
          justify-content flex-end
          align-items center
          padding 20px 30px
          margin-top auto
</style>
